import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckIcon, LoaderIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
import { IMAGES, PRICES } from '../data/funnel';
import { formatUsd, sumUsd } from '../utils/currency';
import { useOrder } from '../contexts/OrderContext';
import { CheckoutSteps } from '../components/CheckoutSteps';
export function CheckoutPage() {
  const navigate = useNavigate();
  const {
    hasBump,
    toggleBump,
    setBuyer
  } = useOrder();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [card, setCard] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading'>('idle');
  const [error, setError] = useState<string | null>(null);
  const total = sumUsd(PRICES.blueprint, hasBump ? PRICES.bump : 0);
  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!name.trim() || !email.includes('@') || card.replace(/\s/g, '').length < 12) {
      setError('Revisa tu nombre, email y número de tarjeta para continuar.');
      return;
    }
    setError(null);
    setStatus('loading');
    setBuyer(name.trim(), email.trim());
    window.setTimeout(() => navigate('/oferta-especial'), 900);
  }
  const field = 'w-full rounded-lg border border-navy-deep/15 bg-paper px-3.5 py-3 text-[0.95rem] text-navy-deep outline-none transition-colors duration-150 ease-out placeholder:text-navy/35 focus:border-navy focus:ring-2 focus:ring-navy/15';
  return <main className="w-full bg-cream pb-24" data-id="element-78" data-mp="ku12o4vxglgt">
      <header className="border-b border-navy-deep/10 bg-paper" data-id="element-79" data-mp="g0y4fjg7gnua">
        <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-between gap-3 px-5 py-3.5" data-id="element-80" data-mp="fzeqw0lxoqw7">
          <span className="font-display text-base font-bold text-navy-deep" data-id="element-81" data-mp="631xz4y7qh2i">
            Protocolo de Biohacking
          </span>
          <CheckoutSteps current={1} data-id="element-82" data-mp="21q3om4e97nz" />
        </div>
      </header>

      <div className="mx-auto max-w-5xl px-5 pt-10" data-id="element-83" data-mp="3t7rgp07x6bc9">
        <h1 className="font-display text-[1.75rem] font-bold leading-tight text-navy-deep sm:text-[2.25rem]" data-id="element-84" data-mp="3t89n2poaq5xw">
          ¡Excelente decisión! Estás a un paso de proteger la vida de tu mejor amigo.
        </h1>
        <p className="mt-3 max-w-2xl text-base text-navy/65" data-id="element-85" data-mp="3nn22i2vptoem">
          Completa tus datos y recibirás el acceso en tu correo en menos de 60 segundos.
        </p>

        <div className="mt-9 grid gap-8 lg:grid-cols-[1.25fr_1fr] lg:gap-12" data-id="element-86" data-mp="3ek9bm0qg3epb">
          <form onSubmit={handleSubmit} noValidate className="min-w-0" data-id="element-87" data-mp="65hi8oqemg6c">
            <fieldset className="rounded-xl border border-navy-deep/10 bg-paper p-6" data-id="element-88" data-mp="67c0twe7dw79">
              <legend className="px-2 text-xs font-semibold uppercase tracking-[0.14em] text-navy/50" data-id="element-89" data-mp="b3ixeykplvcj">
                Tus datos
              </legend>
              <div className="grid gap-4" data-id="element-90" data-mp="1dr2224scy70">
                <div data-id="element-91" data-mp="1coea32rfbvb">
                  <label htmlFor="name" className="mb-1.5 block text-sm font-medium text-navy-deep" data-id="element-92" data-mp="1c6amldrpvdd">
                    Nombre completo
                  </label>
                  <input id="name" value={name} onChange={e => setName(e.target.value)} className={field} placeholder="Sarah Miller" autoComplete="name" data-id="element-93" data-mp="tweiv5cr1r2a" />
                </div>
                <div data-id="element-94" data-mp="2nfn77jkf5uo5">
                  <label htmlFor="email" className="mb-1.5 block text-sm font-medium text-navy-deep" data-id="element-95" data-mp="2jbxjewbkjh46">
                    Email para el acceso
                  </label>
                  <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} className={field} placeholder="sarah@email.com" autoComplete="email" data-id="element-96" data-mp="1vmmqu24dgt14" />
                </div>
              </div>
            </fieldset>

            <fieldset className="mt-5 rounded-xl border border-navy-deep/10 bg-paper p-6" data-id="element-97" data-mp="3g0dch2dw08m1">
              <legend className="px-2 text-xs font-semibold uppercase tracking-[0.14em] text-navy/50" data-id="element-98" data-mp="3b2li81prsaeo">
                Pago
              </legend>
              <div className="grid gap-4" data-id="element-99" data-mp="f6qohvzp98ue">
                <div data-id="element-100" data-mp="f7s5eh3ecpk1">
                  <label htmlFor="card" className="mb-1.5 block text-sm font-medium text-navy-deep" data-id="element-101" data-mp="f935o6xmvf6e">
                    Número de tarjeta
                  </label>
                  <input id="card" value={card} onChange={e => setCard(e.target.value)} className={field} placeholder="4242 4242 4242 4242" inputMode="numeric" autoComplete="cc-number" data-id="element-102" data-mp="p67wwl6c60u2" />
                </div>
                <div className="grid grid-cols-2 gap-4" data-id="element-103" data-mp="17vedo2nkkid8">
                  <div data-id="element-104" data-mp="17uw9mjuo0zur">
                    <label htmlFor="exp" className="mb-1.5 block text-sm font-medium text-navy-deep" data-id="element-105" data-mp="1cur3mw9qm5k1">
                      Vencimiento
                    </label>
                    <input id="exp" className={field} placeholder="09 / 28" autoComplete="cc-exp" data-id="element-106" data-mp="1gwvwvtw9x065" />
                  </div>
                  <div data-id="element-107" data-mp="31c20xu2rma2e">
                    <label htmlFor="cvc" className="mb-1.5 block text-sm font-medium text-navy-deep" data-id="element-108" data-mp="2xd1nys6yy1nb">
                      CVC
                    </label>
                    <input id="cvc" className={field} placeholder="123" autoComplete="cc-csc" data-id="element-109" data-mp="2sdypjqlhutob" />
                  </div>
                </div>
              </div>
            </fieldset>

            <div className={`mt-5 rounded-xl border-2 border-dashed p-6 transition-colors duration-150 ease-out ${hasBump ? 'border-gold bg-gold-pale/50' : 'border-gold/60 bg-gold-pale/25'}`} data-id="element-110" data-mp="3l12r1lldopvc">
              <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-alert" data-id="element-111" data-mp="36drcrbxtarrj">
                Solo disponible en esta página
              </p>
              <div className="mt-3 flex flex-col gap-4 sm:flex-row" data-id="element-112" data-mp="7p2dy4kjjf90">
                <div className="min-w-0 flex-1" data-id="element-113" data-mp="2vpzuodhmqui">
                  <h2 className="font-display text-lg font-bold text-navy-deep" data-id="element-114" data-mp="2uy2p948sl24">
                    El Interruptor de Dieta Natural
                  </h2>
                  <p className="mt-2 text-[0.95rem] leading-relaxed text-navy/75" data-id="element-115" data-mp="2155d73jl0gz5">
                    El 40% de los dueños fallan al cambiar la dieta porque no conocen los tiempos de
                    transición. Con este mini-manual, aseguras una digestión perfecta desde el día 1.
                  </p>
                  <label htmlFor="bump" className="mt-4 flex cursor-pointer items-start gap-3 rounded-lg bg-paper p-4 shadow-card" data-id="element-116" data-mp="1dfujg60nfmui">
                    <input id="bump" type="checkbox" checked={hasBump} onChange={toggleBump} className="mt-0.5 h-5 w-5 shrink-0 cursor-pointer accent-navy-deep" data-id="element-117" data-mp="14h92ugeqmhwd" />
                    <span className="text-[0.95rem] font-semibold leading-snug text-navy-deep" data-id="element-118" data-mp="33s0gzme9pwgt">
                      SÍ, AGREGAR POR SOLO ${PRICES.bump} — La guía paso a paso para pasar a comida
                      natural sin diarreas ni errores comunes.
                    </span>
                  </label>
                </div>
                <img src={IMAGES.food} alt="Guía de transición a comida natural" className="h-28 w-full rounded-lg object-cover sm:h-auto sm:w-32" data-id="element-119" data-mp="3mqlgof8groqn" />
              </div>
            </div>

            {error && <p role="alert" className="mt-5 rounded-lg bg-alert/10 px-4 py-3 text-sm text-alert" data-id="element-120" data-mp="3rnvdify6n2oi">
                {error}
              </p>}

            <button type="submit" disabled={status === 'loading'} className="mt-6 flex w-full items-center justify-center gap-2 rounded-lg bg-navy-deep px-6 py-4 text-lg font-bold text-paper transition-colors duration-150 ease-out hover:bg-navy disabled:opacity-70" data-id="element-121" data-mp="5hgdca6kpd8i">
              {status === 'loading' ? <>
                  <LoaderIcon className="h-5 w-5 animate-spin" data-id="element-122" data-mp="30skzyqne9c2j" />
                  Procesando pago seguro...
                </> : <>
                  <LockIcon className="h-5 w-5" data-id="element-123" data-mp="35k31pgx8rgok" />
                  Completar pedido — ${formatUsd(total)}
                </>}
            </button>
            <p className="mt-3 text-center text-xs text-navy/55" data-id="element-124" data-mp="2cvdztfod37br">
              Pago cifrado de 256 bits. Garantía de devolución de 30 días.
            </p>
          </form>

          <aside className="lg:sticky lg:top-8 lg:self-start" data-id="element-125" data-mp="2lvajt3zt3i0h">
            <div className="rounded-xl border border-navy-deep/10 bg-paper p-6" data-id="element-126" data-mp="2ltzegzqpq279">
              <h2 className="text-xs font-semibold uppercase tracking-[0.14em] text-navy/50" data-id="element-127" data-mp="2qv6koud7itbt">
                Tu pedido
              </h2>
              <div className="mt-4 flex gap-4" data-id="element-128" data-mp="17fmdvb61674">
                <img src={IMAGES.cover} alt="Portada del Protocolo de Biohacking" className="h-24 w-20 rounded-md object-cover" data-id="element-129" data-mp="634u4lxc9tei" />
                <div className="min-w-0" data-id="element-130" data-mp="ba1kfj8o7bb2">
                  <p className="font-display text-base font-bold leading-snug text-navy-deep" data-id="element-131" data-mp="bbclhbaqe4yh">
                    Protocolo de Biohacking para Bulldogs Franceses
                  </p>
                  <p className="mt-1 text-xs text-navy/55" data-id="element-132" data-mp="2gg5nzwi9u1n">Plan de 30 días · acceso inmediato</p>
                </div>
              </div>

              <dl className="mt-5 space-y-2.5 border-t border-navy-deep/10 pt-4 text-sm" data-id="element-133" data-mp="3oo66vxq6ed52">
                <div className="flex justify-between text-navy/75" data-id="element-134" data-mp="3jotiv9nkj00w">
                  <dt data-id="element-135" data-mp="3jp3b73w35j9r">Protocolo completo</dt>
                  <dd data-id="element-136" data-mp="3fnq5quwwni3d">${formatUsd(PRICES.blueprint)}</dd>
                </div>
                {hasBump && <div className="flex justify-between font-medium text-navy-deep" data-id="element-137" data-mp="1hxqbct8z61kk">
                    <dt data-id="element-138" data-mp="1dvbsi95b31ta">Interruptor de Dieta Natural</dt>
                    <dd data-id="element-139" data-mp="1dtqwsg799ctu">${PRICES.bump}</dd>
                  </div>}
                <div className="flex justify-between text-navy/55" data-id="element-140" data-mp="17v5qfcj6crxh">
                  <dt data-id="element-141" data-mp="13vwuc10nwhyr">Descuento de lanzamiento</dt>
                  <dd data-id="element-142" data-mp="13x7yi1y0rrqe">−${formatUsd(PRICES.blueprintValue - PRICES.blueprint)}</dd>
                </div>
              </dl>

              <div className="mt-4 flex items-baseline justify-between border-t border-navy-deep/10 pt-4" data-id="element-143" data-mp="1cvtnofxzy505">
                <span className="text-sm font-semibold text-navy-deep" data-id="element-144" data-mp="p5zbm0li4kgy">Total hoy</span>
                <span className="font-display text-3xl font-bold text-navy-deep" data-id="element-145" data-mp="k7620j9c5dm2">
                  ${formatUsd(total)}
                </span>
              </div>

              <ul className="mt-5 space-y-2 text-xs text-navy/60" data-id="element-146" data-mp="yxd8e0m2j66e">
                {['Acceso de por vida', 'Descarga en PDF y móvil', 'Actualizaciones incluidas'].map(b => <li key={b} className="flex items-center gap-2" data-id="element-147" data-mp="6dwu6n11d05n">
                      <CheckIcon className="h-3.5 w-3.5 text-gold" data-id="element-148" data-mp="1fmymbbefxji" />
                      {b}
                    </li>)}
              </ul>
            </div>

            <p className="mt-4 flex items-start gap-2 px-1 text-xs leading-relaxed text-navy/55" data-id="element-149" data-mp="2hv00kkah0u4m">
              <ShieldCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-navy/40" data-id="element-150" data-mp="2444qx5s5e8zz" />
              Si en 30 días no ves cambios en la movilidad o la piel de tu perro, escríbenos y te
              devolvemos cada centavo.
            </p>
          </aside>
        </div>
      </div>
    </main>;
}